import { Injectable } from '@angular/core';
import { MantenimientoEntidadesControlFilters } from '../models/entidad-control-filters.component';
import { GestionLicenciasFilters } from '../models/gestion-licencias-filters.component';
import { GestionLicenciasHistoryFilters } from '../models/gestion-licencias-history-filters.component';
import { GestionRoyaltiesFilters } from '../models/gestion-royalties-filters.component';
import { LogsFilters } from '../models/logs-filters.component';
import { MantenimientoMunicipiosFilters } from '../models/mantenimiento-municipios-filters.component';
import { MantenimientoPaisesFilters, PaisIdiomaFilters } from '../models/mantenimiento-paises-filters.model';
import { RegistroActividadFilters } from '../models/registro-actividad-filters.components';
import { MantenimientoVersionesEtiquetadoFilters } from '../models/versiones-etiquetado-filters.component';
import { CentralNotificacionesFilters, NotificacionFilters } from '../models/central-notificaciones-filters.component';
import { CsvLogsFilters } from '../models/csv-logs-filters.component';

@Injectable()
export class AdminContextService {
    mantenimientoPaisesFilters: MantenimientoPaisesFilters;
    paisIdiomaFilters: PaisIdiomaFilters;
    mantenimientoMunicipiosFilters: MantenimientoMunicipiosFilters;
    gestionLicenciasFilters: GestionLicenciasFilters;
    gestionLicenciasHistoryFilters: GestionLicenciasHistoryFilters;
    gestionRoyaltiesFilters: GestionRoyaltiesFilters;
    mantenimientoEntidadesControlFilters: MantenimientoEntidadesControlFilters;
    logsFilters: LogsFilters;
    csvLogsFilters: CsvLogsFilters;
    registroActividadFilters: RegistroActividadFilters;
    manteimientoVersionesEtiquetadoFilters: MantenimientoVersionesEtiquetadoFilters;
    centralNotificacionesFilters: CentralNotificacionesFilters;
    notificacionFilters: NotificacionFilters;
}
